import React, { createContext, useState ,useEffect } from "react";
import useMedia from "use-media";
const GlobalContext = createContext();
const { Provider } = GlobalContext;

const GlobalProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setErrorRecived] = useState("");
  const isMobile = useMedia({ maxWidth: "991px" });
  const [isToggle, setIsToggle] = useState(isMobile ? true :false);
  const [password, setPassword] = useState("1234");
  useEffect(() => {
      if(isMobile)
      {
        setIsToggle(true)
      }

}, [isMobile]);
  return (
    <Provider
      value={{
        loading,
        error,
        setLoading,
        setErrorRecived,
        isToggle,
        setIsToggle,
        password,
        setPassword
      }}
    >
      {children}
    </Provider>
  );
};

export { GlobalProvider, GlobalContext };
